(function() {
	/**
	 * Renders main page template and structure
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderMainContent = function() {
		document.title = {
			'de': 'Autonome Provinz Bozen - S\u00fcdtirol',
			'it': 'Provincia autonoma di Bolzano - Alto Adige',
			'lld': 'Provinzia autonoma de Bulsan - S\u00fcdtirol',
			'en': 'Autonomous Province of Bozen/Bolzano - South Tyrol'
		}[(/^(de|it|lld|en)$/.test(WebBaseAprovLV.lang) ? WebBaseAprovLV.lang : 'de')];
		document.documentElement.lang = WebBaseAprovLV.lang || 'de';
		let bdy = document.querySelector('body');
		if (bdy && WebBaseAprovLV.config.environment !== 'prod') {
			bdy.setAttribute('data-kontent-language-codename', WebBaseAprovLV.lang || 'de');
		}
		return $.when(
			/* WebBaseAprovLV.Utils.getKKData('/root_navigation?depth=4'), */ /* TODO: Old style navigtion. Fix/remove it later. */
			WebBaseAprovLV.Utils.getKKData('/homepage?elements=title,navigation_title,show_in_navigation,subpages,url,external_url&depth=6'), /* Navigation hierarchy. Maybe GraphQL someday? */
			/* WebBaseAprovLV.Utils.fetchAsync({})('/json/nav-aprov-sidebar_' + (WebBaseAprovLV.lang || 'de') + '.json'), */ /* OLD STATIC THEMEMENU */
			/* WebBaseAprovLV.Utils.getKKData('/footer_navigation_item?depth=1'), */ /* TODO: Originally intended as footer navigtion. Fix it later. Not relevant by now. */
			WebBaseAprovLV.Utils.getKKData('/system_settings?depth=2'),
			WebBaseAprovLV.Utils.getI18nData()
		).then(function(/* navrootold, */ navroot, /* navbrand, navfooter, */ settings, i18n) {
			var lang = WebBaseAprovLV.lang || 'de';
			var data;
			WebBaseAprovLV.i18n[lang] = WebBaseAprovLV.i18n[lang] || (WebBaseAprovLV.i18n[lang] = (i18n && i18n.length) ? i18n[0] : null);
			data = {
				navrootold: {}, /* WebBaseAprovLV.Utils.getKKViewModel(navrootold[0]), */ /* TODO: Old style navigtion. Fix/remove it later. */
				navroot: WebBaseAprovLV.Utils.getKKViewModel(navroot[0]),
				navbrand: {}, /* WebBaseAprovLV.Utils.getKKViewModel(navbrand[0]), */ /* OLD STATIC THEMEMENU */
				navfooter: {}, /* WebBaseAprovLV.Utils.getKKViewModel(navfooter[0]), */ /* TODO: Originally intended as footer navigtion. Fix it later. Not relevant by now. */
				settings: WebBaseAprovLV.Utils.getKKViewModel(settings[0])
			};
			WebBaseAprovLV.Cache.set(['page', WebBaseAprovLV.lang, 'main'].join('.'), data);
			return WebBaseAprovLV.Utils.transitionTo({
				element: $('.js-main-content'),
				template: 'templates/main.ejs.html?v=' + WebBaseAprovLV.version.template,
				data: data
			});
		}).then(function(data) {
			if ($('#toTop').length === 0) {
				$('body').append('<div id="toTop" class="btn"><span class="fa fa-angle-double-up"></span></div>');
				$(window).scroll(function() {
					0 != $(this).scrollTop() ? $('#toTop').fadeIn() : $('#toTop').fadeOut();
				});
				$('#toTop').click(function() {
					return $('html, body').animate({
						scrollTop: 0
					}, 600);
				});
			}
			$('#menu_btn, #sidebar > ul > li > a').on('click', function() {
				var this$ = $(this);
				var btn$ = this$;
				var el$ = $('#' + this$.attr('aria-controls'));
				if ($('body').hasClass('open')) {
					$('body').removeClass('open');
					$('#sidebar').attr('aria-hidden', 'true');
					$('#menu_btn').attr('aria-expanded', 'false');
				} else {
					$('body').addClass('open');
					el$.attr('aria-hidden', 'false');
					btn$.attr('aria-expanded', 'true');
				}
			});
			$('#dismiss').on('click', function() {
				$('body').removeClass('open');
				$('#sidebar').attr('aria-hidden', 'true');
				$('#menu_btn').attr('aria-expanded', 'false');
			});
			return data;
		}).promise();
	};
})();
